module.exports = __webpack_public_path__ + "static/register-image-b7ad5ec0b443a286f3da3f3c58ece30d.png";